import en from './en.json'
import country_en from './country/en.json'
import country_zhTw from './country/zh-tw.json'
import country_zhCn from './country/zh-cn.json'
import zhCn from './zh-cn.json'
import opencc from '../node-opencc/lib/index'
import zhTw from './zh-tw.json'
import ja from './ja.json'
import ro from './ro.json'
import tr from './tr.json'
import id from './id.json'
import de from './de.json'

Object.keys(zhCn).forEach((key)=>{
  if(_.isNil(zhTw[key]))
    zhTw[key] = opencc.simplifiedToTraditional(zhCn[key])
})

const mergeCountry = (lang, country)=>{
  const countryMap = {}
  country.forEach((c)=>countryMap[`country.${c.code}`]=c.label)
  return Object.assign({}, lang, countryMap)
}

export default {
  en: mergeCountry(en, country_en),
  'zh-cn':mergeCountry(zhCn, country_zhCn),
  'zh-tw':mergeCountry(zhTw, country_zhTw),
  ja: mergeCountry(ja, country_en),
  ro: mergeCountry(ro, country_en),
  tr: mergeCountry(tr, country_en),
  id: mergeCountry(id, country_en),
  de: mergeCountry(de, country_en),
}



// WEBPACK FOOTER //
// ./src/lang/index.js